export const PWA_ONBOARDING = 'DLzPhmLu'
